import React from 'react';
import './Tile.css';
import { canAccessMenu, hasPermission } from '../../utils/permissions';
import { useCurrentMenuKey } from '../../hooks/useMenuCatalog';

const Tile = ({
  icon,
  title,
  label,
  description,
  onClick,
  disabled = false,
  menuKey,
  permissionKey,
  requiresWrite = false,
  ...rest
}) => {
  const currentMenuKey = useCurrentMenuKey();
  const resolvedMenu = menuKey || currentMenuKey;

  if (permissionKey) {
    if (!hasPermission(permissionKey)) {
      return null;
    }
  } else if (resolvedMenu) {
    if (!canAccessMenu(resolvedMenu)) {
      return null;
    }
    // Legacy requiresWrite without permissionKey: hide if menu off only
    if (requiresWrite && !canAccessMenu(resolvedMenu)) {
      return null;
    }
  }

  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };

  const handleKeyDown = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (onClick) {
        onClick(e);
      }
    }
  };

  return (
    <div
      className={`rt-tile ${disabled ? 'rt-tile-disabled' : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
      {...rest}
    >
      <div className="rt-tile-content">
        {icon && (
          <span className="rt-tile-icon" aria-hidden="true">
            {icon}
          </span>
        )}
        <div className="rt-tile-text">
          <div className="rt-tile-title">{title || label}</div>
          {description && <div className="rt-tile-description">{description}</div>}
        </div>
      </div>
    </div>
  );
};

export default Tile;
